import { useContext } from "react";
import { PlayerContext } from "../../hooks/PlayerStore";
import { NavLink } from "react-router";
import { UserContext } from "../../hooks/UserStore";

const Header = () => {
  const player = useContext(PlayerContext);
  const user = useContext(UserContext);

  return (
    <>
      <div className="fixed-top nav-container main-nav-container mx-2">
        <nav className="navbar navbar-expand-sm navbar-light bg-light sticky-top">
          <div className="container-fluid">
            <div className="expand navbar-expand" id="navbarSupportedContent">
              <ul className="navbar-nav me-auto mb-lg-0">
                <li className="nav-item">
                  <NavLink
                    className="nav-link pe-0"
                    aria-current="page"
                    to="/"
                    activeClassName="active"
                  >
                    {user.user && (
                      <span className={`me-2 fi fi-${user.user.flag}`}></span>
                    )}
                    Learn
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    className="nav-link pe-0"
                    to="/preferences"
                    activeClassName="active"
                  >
                    Preferences
                  </NavLink>
                </li>
              </ul>
            </div>

            <div className="controls">
              <button
                className="btn btn-light"
                hx-post="/player/prev"
                hx-swap="none"
                onClick={() => {
                  player.prev();
                }}
              >
                <i className="bi bi-skip-backward-circle-fill"></i>
              </button>
              <button
                className="btn btn-light"
                hx-post="/player/playPause"
                hx-swap="none"
                onClick={() => {
                  player.playPause();
                }}
              >
                <i
                  className={`bi bi-${
                    player.track.isPlaying ? "pause" : "play"
                  }-circle-fill`}
                ></i>
              </button>
              <button
                className="btn btn-light"
                hx-post="/player/next"
                hx-swap="none"
                onClick={() => {
                  player.next();
                }}
              >
                <i className="bi bi-skip-forward-circle-fill"></i>
              </button>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
};

export default Header;
